/**
 * Canonical tab manifest - PROD-578.
 *
 * Tab IDs and order are load-bearing per ORIGINAL-PROTOTYPE-PROMPTS Prompt
 * 1 / 11 / 14 + behavioral extraction §6 PROD-568 amendment. Don't reorder.
 *
 * Lives in its own module (not co-located with `TabNav.tsx`) so HMR /
 * react-refresh stays clean - `react-refresh/only-export-components` rule
 * requires component files to export only components.
 */
/**
 * Closed enum of canonical tab ids. Exported as a `const` tuple so the
 * telemetry schema (PROD-582 `app_init.entryTab`) can derive a Zod enum
 * from the same source of truth. Order matches `TABS` below; reordering
 * is breaking per behavioral extraction §6.
 */
export const TAB_IDS = [
  'studio',
  'arch',
  'sched',
  'emr',
  'pv',
  'proms',
  'cap',
  'learn',
] as const;

export type TabId = (typeof TAB_IDS)[number];

export interface TabConfig {
  id: TabId;
  label: string;
  path: string;
}

export const TABS: readonly TabConfig[] = [
  { id: 'studio', label: 'Pathway Studio', path: '/' },
  { id: 'arch', label: 'Architecture', path: '/architecture' },
  { id: 'sched', label: 'Scheduling', path: '/scheduling' },
  { id: 'emr', label: 'ClinicalDesk', path: '/clinical-desk' },
  { id: 'pv', label: 'PathwayView', path: '/pathway-view' },
  { id: 'proms', label: 'PROMs', path: '/proms' },
  { id: 'cap', label: 'Session Capture', path: '/session-capture' },
  { id: 'learn', label: 'Learning Loop', path: '/learning-loop' },
];
